export const paths = {
  HOME: '/',
  PRIVACY_POLICY: '/privacy-policy/',
  TERMS_OF_SERVICE: '/terms-of-service/',
  INFORMATION_SECURITY_POLICY: '/information-security-policy/',
  CASE_STUDIES: {
    HOME: '/case-studies/',
    USING_ONOS_SDN_P4: '/case-study/using-onos-sdn-controller-with-p4-programmable-smartnics-to-offload-vnfs/',
    USING_ONOS_SDN_CONTROLLER: '/case-study/using-onos-sdn-controller-to-control-heterogeneous-data-plane/',
  },
  BLOG: '/blog/',
  CONTACT: '/contact/',
  CAREERS: '/careers/',
  NEWSLETTER: '/newsletter/',
  INTERNET_OF_THINGS: '/internet-of-things/',
  NETWORK_ENGINEERING_AUTOMATION: '/expertise/network-engineering-automation/',
  NETWORK_ENGINEERING_CLOUD: '/expertise/network-engineering-cloud/',
  NETWORK_ENGINEERING_MONITORING: '/expertise/network-engineering-monitoring/',
  TUNGSTEN_FABRIC: '/tungsten-fabric/',
  GLOSSARY: {
    HOME: '/glossary/',
    CLOUD_NATIVE: '/glossary/cloud-native/',
    SOFTWARE_DEFINED_NETWORKING: '/glossary/software-defined-networking',
    SDN_CONTROLLER: '/glossary/sdn-controller/',
  },
  UX_SHOWCASE: '/ux-showcase/',
  UX_SCORE: '/ux-score/',
  ABOUT: '/about/',
  NEWS: '/news/',
  TECHNOLOGIES: '/technology-stack/',
  FAST_TRACK_DEMO: '/fast-track-demo/',
  RESOURCES: {
    BASE: '/resources/',
    CI_CD_PIPELINE: '/resources/ci-cd-pipeline/',
    PODCAST: {
      HOME: '/resources/podcasts/',
      NET_MONITORING: '/resources/podcasts/network-and-service-monitoring-in-heterogeneous-environments/',
      SDN: '/resources/podcasts/sdn-revolution-or-evolution-of-traditional-networks/',
    },
    MIN_VIABLE_PROD: '/resources/minimum-viable-product-for-startups/',
    GOLANG_CHECKLIST: '/resources/golang-checklist/',
    UX_CHECKLIST: '/resources/ux-design-checklist/',
  },
  SERVICES: {
    GO: '/services/golang-development/',
    PYTHON: '/services/python-development/',
    NETWORK_SOFTWARE_ENGINEERING: '/services/network-software-engineering/',
    R_D: '/services/rd-services/',
    SOFTWARE_OUTSOURCING: '/services/software-outsourcing/',
    P4: '/services/p4-development/',
    RUST: '/services/rust-development/',
    C_AND_CPP: '/services/c-and-cpp-development/',
    CUSTOM_DEVELOPMENT: '/services/custom-software-development/',
    MVP: '/services/mvp-development/',
    SOFTWARE_DEVELOPMENT: '/services/software-development-for-startups/',
    UX_UI_DESIGN: '/services/ux-ui-design/',
    DATA_ENGINEERING: '/services/data-engineering/',
    NETWORK_PROFESSIONAL_SERVICES: '/services/network-professional-services/',
    LOW_LEVEL: '/services/low-level-programming-engineering/',
    REACT: '/services/react-development/',
    ANGULAR: '/services/angular-development/',
    DEVOPS: '/services/devops/',
    FRONTEND: '/services/frontend-development/',
    BACKEND: '/services/backend-development/',
    JAVA: '/services/java-development/',
    TEST_AUTOMATION: '/services/test-automation/',
    PRODUCT_DESIGN: '/services/product-design/',
    NETWORK_SOLUTION_SERVICES: '/services/networks/',
  },
};
